import {
  Age,
  BodyTypes,
  Colours,
  Doors,
  EngineSize,
  FuelTypes,
  MakesModels,
  TransmissionTypes,
} from '@cinch/oxd-utils/filters/src'
import { getMake } from '@cinch/oxd-utils/manufacturers/src'

export enum FILTER_TYPE {
  RADIO,
  SELECT,
  CHECKBOX,
  MAKE_MODEL,
  SELECT_RANGE,
  SLIDER,
}

export const filtersConfig = [
  {
    label: 'Make and Model',
    type: FILTER_TYPE.MAKE_MODEL,
    make: {
      label: 'Make',
      key: 'make',
      options: MakesModels.map((data) => ({ label: getMake(data.Make), value: data.Make })),
    },
    model: {
      label: 'Model',
      key: 'selectedModel',
    },
  },
  {
    label: 'Age',
    type: FILTER_TYPE.SELECT_RANGE,
    from: {
      key: 'fromYear',
      options: Age,
      initialValue: -1,
    },
    to: {
      key: 'toYear',
      options: Age,
      initialValue: -1,
    },
  },
  {
    label: 'Mileage',
    type: FILTER_TYPE.SLIDER,
    key: 'mileage',
    options: {
      min: -1,
      max: 70000,
      step: 5000,
      initialValue: -1,
      valueFormatter: (value: any) => {
        const val = typeof value === 'number' ? value : parseInt(value, 10)
        if (isNaN(val) || val === 0 || val === -1) {
          return 'No max mileage set'
        } else {
          return `Up to ${val.toLocaleString()} miles`
        }
      },
      parse: (val: any) => (val > 0 ? parseInt(val, 10) + 1 : val),
    },
  },
  {
    label: 'Engine size',
    type: FILTER_TYPE.SELECT_RANGE,
    from: {
      key: 'fromEngineSize',
      options: EngineSize,
      initialValue: -1,
    },
    to: {
      key: 'toEngineSize',
      options: EngineSize,
      initialValue: -1,
    },
  },
  {
    label: 'Body style',
    type: FILTER_TYPE.CHECKBOX,
    key: 'bodyType',
    options: BodyTypes,
  },
  {
    label: 'Gearbox',
    type: FILTER_TYPE.CHECKBOX,
    key: 'transmissionType',
    options: TransmissionTypes,
  },
  {
    label: 'Fuel type',
    type: FILTER_TYPE.CHECKBOX,
    key: 'fuelType',
    options: FuelTypes,
  },
  {
    label: 'Doors',
    type: FILTER_TYPE.CHECKBOX,
    key: 'doors',
    options: Doors,
  },
  {
    label: 'Colour',
    type: FILTER_TYPE.CHECKBOX,
    key: 'colour',
    options: Colours,
  },
]
